import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  loadFreezeDropdownDataRequest: [''],
  loadFreezeDropdownDataSuccess: ['freezeDropdownDetails'],
  loadFreezeDropdownDataFailure: ['error'],

  loadCancelDropdownDataRequest: [''],
  loadCancelDropdownDataSuccess: ['cancelDropdownDetails'],
  loadCancelDropdownDataFailure: ['error'],

  submitFreezeRequest: ['payload'],
  submitFreezeSuccess: ['freezeFormDetails'],
  submitFreezeFailure: ['error'],

  submitCancelRequest: ['payload'],
  submitCancelSuccess: ['cancelFormDetails'],
  submitCancelFailure: ['error'],

  loadCancelIframeUrlRequest: ['caId'],
  loadCancelIframeUrlSuccess: ['cancelIframeDetails'],
  loadCancelIframeUrlFailure: ['error'],

  loadFreezeIframeUrlRequest: ['caId'],
  loadFreezeIframeUrlSuccess: ['freezeIframeDetails'],
  loadFreezeIframeUrlFailure: ['error'],

  loadFormsDetailsRequest: ['caId'],
  loadFormsDetailsSuccess: ['formsDetails'],
  loadFormsDetailsFailure: ['error'],

  resetCancelFormDetails: [''],
  resetFreezeFormDetails: [''],
  resetIframeDetails: [''],
});

const membershipFormsActions = {
  Types,
  Creators,
};

export default membershipFormsActions;
